import { withTranslation } from "react-i18next";

import GolfDetail from './GolfDetail';

export default withTranslation()(GolfDetail);